<template>
  <dropdown
    v-model="localValue"
    :name="name"
    :options="dropdownOptions"
    :default-option="null"
    required
  />
</template>

<script>
const numberText = [ '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th' ];
import { EventBus } from '@/plugins/bus';

export default {
  name: 'BedroomDropdown',
  props: {
    name: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      required: true,
    },
    // Room number is always one for bedroom dropdown
    roomNumber: {
      type: Number,
      required: true,
      // validator: function (prop) {
      //   if (prop !== 1) {
      //     throw new Error('roomNumber has to be 1 and only 1');
      //   }
      //   return true;
      // },
    },
    // For bedroom the only dropdowns are "First bedroom floor" and "First bedroom windows"
    // Therefore type doesn't change, only location (front, middle and rear)
    type: {
      type: String,
      required: true,
      // validator: (prop) => {
      //   if ([ 'window', 'floor' ].indexOf(prop) === -1) {
      //     throw new Error("type prop accepts only [ 'window', 'floor' ]");
      //   }
      //   return true;
      // },
    },

    // Location is the v-model!
    value: {
      type: String,
      default: 'front',
      // validator: (prop) => {
      //   if ([ 'front', 'middle', 'rear' ].indexOf(prop) === -1) {
      //     throw new Error("location (v-model) accepts only [ 'front', 'middle', 'rear' ]");
      //   }
      //   return true;
      // },
    },
  },
  data() {
    return {
      dropdownOptions: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        EventBus.$emit('new-location', localValue, this.index);
        this.$emit('input', localValue);
      },
    },
  },
  beforeMount() {
    let nroBedroom = numberText[(this.roomNumber-1)];
    if (this.type === 'window') {
      this.dropdownOptions = {
        'front' : `${nroBedroom} bedroom window sill (front)`,
        'middle': `${nroBedroom} bedroom window sill (middle)`,
        'rear': `${nroBedroom} bedroom window sill (rear)`, 
      };
    } else {
      this.dropdownOptions = {
        'front' : `${nroBedroom} bedroom floor (front)`,
        'middle': `${nroBedroom} bedroom floor (middle)`,
        'rear': `${nroBedroom} bedroom floor (rear)`, 
      };
    }
  },
};
</script>

<style>

</style>